export type StartingPoint = "airport" | "milan" | "como" | "bellagio" | "varenna" | "west";

export type MovementFinderOption = {
  id: StartingPoint;
  label: string;
  detail: string;
  query: string;
};

export const movementFinderOptions: MovementFinderOption[] = [
  { id: "airport", label: "Airport", detail: "Malpensa, Linate and Bergamo", query: "Lake Como airport arrival Malpensa Linate" },
  { id: "milan", label: "Milan", detail: "Reach Lake Como from the city", query: "Milan to Lake Como Varenna train" },
  { id: "como", label: "Como", detail: "Start from the southern lake", query: "Como Lake Como ferry bus transport" },
  { id: "bellagio", label: "Bellagio", detail: "Start from the central lake", query: "Bellagio Varenna Menaggio ferry Lake Como" },
  { id: "varenna", label: "Varenna / eastern shore", detail: "Cross or continue around the lake", query: "Varenna Lake Como ferry eastern shore" },
  { id: "west", label: "Menaggio / western shore", detail: "Western-shore connections", query: "Menaggio western shore Lake Como transport" },
];
